import { SVGProps } from 'react';

export const SvgExport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8306 0C12.0185 0 12.1987 0.0743695 12.3315 0.206748L15.9449 3.80736C16.2215 4.08303 16.2215 4.52997 15.9449 4.80563C15.6682 5.0813 15.2197 5.0813 14.9431 4.80563L11.8306 1.70415L8.71821 4.80563C8.44157 5.0813 7.99306 5.0813 7.71642 4.80563C7.43978 4.52997 7.43978 4.08303 7.71642 3.80736L11.3297 0.206748C11.4626 0.0743695 11.6428 0 11.8306 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8306 0.0984646C12.2219 0.0984646 12.539 0.414499 12.539 0.804347V15.1084C12.539 15.4982 12.2219 15.8142 11.8306 15.8142C11.4394 15.8142 11.1223 15.4982 11.1223 15.1084V0.804347C11.1223 0.414499 11.4394 0.0984646 11.8306 0.0984646Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.708373 11.3363C1.0996 11.3363 1.41675 11.6523 1.41675 12.0422C1.41675 14.9911 2.41973 17.6234 4.2213 19.5133C6.01755 21.3976 8.64934 22.5882 12 22.5882C15.3507 22.5882 17.9825 21.3976 19.7787 19.5133C21.5803 17.6234 22.5833 14.9911 22.5833 12.0422C22.5833 11.6523 22.9004 11.3363 23.2916 11.3363C23.6828 11.3363 24 11.6523 24 12.0422C24 15.31 22.8858 18.3037 20.8059 20.4856C18.7206 22.6731 15.7066 24 12 24C8.29339 24 5.27937 22.6731 3.19412 20.4856C1.1142 18.3037 0 15.31 0 12.0422C0 11.6523 0.317149 11.3363 0.708373 11.3363Z"
    />
  </svg>
);
